import React from 'react';
import PillboxItem from './PillboxItem';
import styles from './__styles__/index.scss?modules';

const FilterButtons = ({ filterData, activeFilter, onFilterClick }) => {
  return (
    <div className={styles.filterButtons}>
      <div className={styles.container}>
        {filterData.sortedList.map((item, index) => {
          return (
            <div key={`k${index}`}>
              <PillboxItem
                filterItem={item}
                isSelected={item.internalId === activeFilter}
                onFilterClick={onFilterClick}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(FilterButtons);
